<script setup lang="ts" generic="T">
defineProps<{
	define: T;
}>();
</script>

<template>
	<slot v-bind="define" />
</template>
